/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useController } from 'react-hook-form';
import { Form, Input } from 'antd';

const AntdTextField = ({
  disabled,
  setValue,
  control,
  name,
  type,
  label,
  placeholder,
  prefix,
  validateStatus,
  defaultValue,
  errorMsg,
  className,
  onChange,
  style
  // value
}) => {
  const {
    // field: { ...inputProps }
    field
  } = useController({
    name,
    control
  });

  React.useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);
    }
  }, [defaultValue]);

  return (
    <Form.Item
      style={style}
      label={label}
      help={errorMsg}
      validateStatus={validateStatus}
      colon={false}
    >
      <Input
        autoComplete="off"
        autoSave="off"
        disabled={disabled ? disabled : false}
        {...field}
        onChange={(e) => {
          field.onChange(e);
          onChange && onChange(e.target.value);
        }}
        className={className}
        placeholder={placeholder}
        prefix={prefix}
        type={type}
        size="large"
      />
    </Form.Item>
  );
};

export default AntdTextField;
